module.exports = __webpack_public_path__ + "img/Background_Sertifikat.d13209bd.png";